import { Component, Input, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoggedInOnInit } from 'src/app/LoggedInOnInit';
import { ProcteeService } from 'src/app/services/proctor-services/proctee.service';
import { UserService } from 'src/app/services/proctor-services/user.service';
//import TableToExcel from "@linways/table-to-excel";
import { FormsModule } from '@angular/forms';
import { ExamService } from 'src/app/services/exam-service.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { ProctorService } from 'src/app/services/proctor.service';

@Component({
  selector: 'app-procteeflags',
  templateUrl: './procteeflags.component.html',
  styleUrls: ['./procteeflags.component.scss']
})
export class ProcteeflagsComponent extends LoggedInOnInit {
  dtOptions: any = {};
  examid: string = '';
  reqExams: any = [];
  flags: Map<string, any[]> = new Map<string, any[]>();
  tabledata: Map<string, any[]> = new Map<string, any[]>();
  updatingflag = false;
  AiFlaggedFiltered = false;
  config: any = {};
  @Input() proctorfullname;
  p: number;
  itemsPerPage = 50;
  totalItems: number;
  candidateexamno: string = '';
  candidateNos: string[] = [];
  constructor(private procteeservice: ProcteeService, private router: Router, private activatedroute: ActivatedRoute, private userservice: UserService,
    private examService: ExamService, private toastr: ToastrService, private authService: AuthService, private proctorService: ProctorService, private auth: AuthService,) {
    super(router, userservice, activatedroute);
  }

  async ngOnInit() {
    await this.proctorService.getProctorToken().then((u: any) => {
      this.authService.setCookie('authToken', u.data);
      this.authService.setCookie('authCompany', this.auth.user.company);
    });
    const ret = super.ngOnInit();
    if (this.loggedIn()) {
      this.examid = this.examService.selectedExamIds[0].toString() ?? '';
      if (this.examid) {
        const candidates = await this.procteeservice.getFlaggedCandidates(this.examid);
        this.candidateNos = candidates.map(x => x.examNo);
      }

      //var a = ["c","c","v","a"];
      // var a= ['Demo Examination', 'Demo Examination', 'master of nothing', 'master of nothing', 'master of nothing']
      await this.getExams();

      //var a = this.reqExams
      this.config = {
        displayFn: (item: any) => { return item.examName; },
        //displayKey: 'examID',
        search: 'true',
        searchOnKey: 'examName',
        limitTo: 50,
        noResultsFound: 'No results found!',
        searchPlaceholder: 'Enter Exam Name',
        placeholder: 'Select Examination'
      };
    }
    return ret;
  }

  async getExams() {
    let res: any = await this.procteeservice.getReqExams();
    let unique = new Set();
    //debugger
    // res.forEach(r => {
    //   if (!unique.has(r.examID)) {
    //     unique.add(r.examID);
    //     this.reqExams.push(r.examName);
    //   }
    // });
    this.reqExams = res
    return this.reqExams
  }

  async searchClicked() {
    this.resetFlagFilter();
    const examid = this.examid;
    const data: any = await this.procteeservice.getFlags(this.examid);
    this.setflag(data)
  }

  setflag(data: any, page = 1) {
    // this.flags = [];
    // for (const temp of data.ret) {
    //   // if (!this.flags.has(temp.candidateno)) {
    //   //   this.flags.set(temp.candidateno, []);
    //   // }
    //   //this.flags.size
    //   const candidaterecordingsurl = `/videos?candidateno=${temp.candidateno}&examid=${examid}`;
    //   this.flags.push({ examid: this.examid, candidateno: temp.candidateno, reason: temp.reason, reviewcomments: temp.reviewcomments, unflag: temp.unflag, aiflagged: temp.aiflagged, datetimestring: new Date(parseInt(temp.time)).toString(), flagtime: temp.time, candidaterecordingsurl: candidaterecordingsurl, flagID: temp.flagID });
    // }

    this.flags = new Map<string, any[]>();
    for (const temp of data.ret) {
      if (!this.flags.has(temp.candidateno)) {
        this.flags.set(temp.candidateno, []);
      }

      const candidaterecordingsurl = `/exams/${this.examid}/recordings?candidateno=${temp.candidateno}&examid=${this.examid}`;
      this.flags.get(temp.candidateno).push({ examid: this.examid, candidateno: temp.candidateno, reason: temp.reason, reviewcomments: temp.reviewcomments, unflag: temp.unflag, aiflagged: temp.aiflagged, datetimestring: new Date(parseInt(temp.time)).toString(), flagtime: temp.time, candidaterecordingsurl: candidaterecordingsurl, flagID: temp.flagID });
    }

    // this.router.navigate([`/exams/${this.examid}/flags`], { queryParams: { examid: this.examid } });
    this.p = page;
    this.fillTableData();

    this.dtOptions = {
      //ajax: data,      
      // Declare the use of the extension in the dom parameter
      dom: 'Brti',
      pageLength: 50,
      // Configure the buttons
      buttons: [
        'copy', 'csv', 'excel', 'print'
      ]
    };
    this.totalItems = data.totalflags;
  }

  async searchByExamID() {
    this.resetFlagFilter();
    const data: any = await this.procteeservice.getFlags(this.examid, this.candidateexamno);
    this.setflag(data)
  }

  async getPage(page) {
    this.tabledata.clear();
    if (!this.examid || !this.candidateexamno) {
      console.log('Please select an exam and Candidate Number');
      return;
    }
    const data: any = await this.procteeservice.getFlags(this.examid, this.candidateexamno, page, this.itemsPerPage);
    this.setflag(data, page)
  }
  fillTableData() {
    this.tabledata.clear();
    this.flags.forEach((value, key) => {
      this.tabledata.set(key, value);
    })
  }
  resetFlagFilter() {
    const flagfilter = document.getElementById('flagfilter') as HTMLSelectElement;
    flagfilter.selectedIndex = 0;
  }

  flagFilter(filter) {
    this.AiFlaggedFiltered = !this.AiFlaggedFiltered;
    this.tabledata.clear();
    if (filter === 'ai') {
      this.flags.forEach((value, key) => {
        if (value[0].aiflagged) {
          this.tabledata.set(key, value)
        }
      })
    }
    else if (filter === 'human') {
      this.flags.forEach((value, key) => {
        if (!value[0].aiflagged) {
          this.tabledata.set(key, value)
        }
      })
    }
    else {
      this.fillTableData();
    }
  }

  selectionChanged(event) {
    this.examid = event.value.examID;
  }

  flagFilterSelectionChanged(event) {
    const filter = event.currentTarget.value;
    this.flagFilter(filter);
  }

  filled() {
    return this.examid;
  }

  asIsOrder(a, b) {
    return 1;
  }

  async updateProcteeFlag(examid: string, candidateno: string, reviewcomments: string, unflag: boolean, flagid: number) {
    try {
      //debugger;
      this.updatingflag = true;
      let res: any = await this.procteeservice.updateProcteeFlag(examid, candidateno, reviewcomments, unflag, this.proctorfullname, flagid);
      if (res.status === "SUCCESS") {
        this.toastr.success('Saved');
      }
      else {
        console.error(res);
        this.toastr.warning("Unable to update flag on third party system");
      }
      this.searchByExamID();
    }
    catch (error) {
      console.error(error);
      this.toastr.error('Unable to save');
    }
    finally {
      this.updatingflag = false;
    }

  }
  async loadCandidateData(examid: string, candidateno: string) {
    this.candidateexamno = candidateno;
    const data: any = await this.procteeservice.getFlags(examid, candidateno);
    this.setflag(data)
  }

  openRecording(candidateflags, flagtime) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/exams/' + this.examid + '/recordings'], {
        queryParams: {
          examid: candidateflags.value[0].examid,
          candidateno: candidateflags.key,
          flagtime: flagtime
        }
      })
    );

    window.open(url, '_blank');
  }
}
